(function($) {
  $(document).ready(function () {
    /* Heade account dropdown */
    $('.header-account-icon').click(function(){
      var aria_controls = $(this).attr('aria-controls');
      $('#'+aria_controls).slideToggle();
    })
    $(document).click(function(event) { 
      var $target = $(event.target);
      if(!$target.closest('.HorizontalList__Item--Account').length && $('#header-account').is(":visible")) {
        $('#header-account').slideUp();
      }        
    });
    /* Heade account dropdown */

    /* Menu hover dropdown */
     $( ".Header__MainNav .HorizontalList__Item" ).hover(
      function() {
        $( this ).addClass('is-expanded').attr('aria-haspopup','false');
        $(this).find('.MegaMenu, .DropdownMenu').attr('aria-hidden','false');
        $("body").addClass('menu-is-expanded');
      }, function() {
        $( this ).removeClass('is-expanded').attr('aria-haspopup','true');
        $(this).find('.MegaMenu, .DropdownMenu').attr('aria-hidden','true');
        $("body").removeClass('menu-is-expanded');
      }
    );
    /* Menu hover dropdown */

    /* menu mobile dropdown */
    $('.Header__Icon--menu').click(function(){
      var data_id = $(this).attr('data-drawer-id');
      if($('#'+data_id).attr('aria-hidden') == 'false') {
        $(this).attr('aria-hidden', 'true');
        $('#'+data_id).attr('aria-hidden', 'true');
        $('html').removeClass('no-scroll');
        $('body').removeClass('menu-is-expanded');
      } else {
        $('#'+data_id).attr('aria-hidden', 'false');
        $(this).attr('aria-hidden', 'false');
        $('html').addClass('no-scroll');
        $('body').addClass('menu-is-expanded');
      }
      $('#'+data_id).toggleClass('active');
      $(this).parents('header').toggleClass('active');
    });  
    
    $('.SidebarMenu .Drawer__Close').click(function(){
      var data_id = $(this).attr('data-drawer-id');
      $('#'+data_id).attr('aria-hidden', 'true');
      $('#'+data_id).removeClass('active');
      $('html').removeClass('no-scroll');
      $('body').toggleClass('menu-is-expanded');
      $(this).parents('header').removeClass('active');
    });
    /* menu mobile dropdown */

    /* Sub menu mobile dropdown */
    $('.HorizontalList__Item--Collapsible').click(function(){
      $(this).parent('.HorizontalList__Item').toggleClass('active');
      $(this).next('.MegaMenu').slideToggle();
      $(this).next('.DropdownMenu').slideToggle();
    });
    /* Sub menu mobile dropdown */
    
    /* Header fixed */ 
    headerFixed();
    /* Header fixed */

    if($('.CustomerReviews-Swiper').length>0) {
      var swiper = new Swiper(".CustomerReviews-Swiper", {
        slidesPerView: 3,
        spaceBetween: 30,
        scrollbar: {
          el: ".swiper-scrollbar"
        },
        breakpoints: {
          1: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30
          },
          1023: {
            slidesPerView: 3,
            spaceBetween: 85
          }
        }
      });
    } 
    
  });
  
  /* Header fixed */
  window.onscroll = function() {headerFixed()};
  var header = document.getElementById("section-header");  
  function headerFixed() {
    var heightHeader = $('#section-header').outerHeight();
    $('body').css("--header-fixed", heightHeader+'px');
    var heightBar = 0;
    if($('#section-announcement').is(":visible")) {
      heightBar = $('#section-announcement').outerHeight() + 9;
    }
    if (window.pageYOffset > heightBar) {
      // header.classList.add("sticky");
      header.setAttribute("data-header-sticky", "true");
      $('.Header__Wrapper--bottom').slideUp();
      $('body').addClass('header-sticky');
    } else {
      // header.classList.remove("sticky");
      header.setAttribute("data-header-sticky", "false");
      $('.Header__Wrapper--bottom').slideDown();
      $('body').removeClass('header-sticky');
    }
  }
  /* Header fixed */
})(jQuery);